import { LoadedConsentManagementInfo } from "@/types/global";
import { makeRequest } from "@/util";
import { updateQuery } from "@/api";

type ToggleConsentManagementConfigRequest = {
  id: string;
  enabled: boolean;
};

type ToggleConsentManagementConfigResponse = {
  config: LoadedConsentManagementInfo;
};

export async function toggleConsentManagementConfig(
  payload: ToggleConsentManagementConfigRequest,
) {
  const res = await makeRequest<ToggleConsentManagementConfigResponse>(
    "toggle_consent_management_config",
    payload,
  );

  updateQuery(["get_consent_management_configs"], (existingData) => {
    if (!existingData) return null;

    return {
      ...existingData,
      configs: {
        ...existingData.configs,
        [res.data.config.type]: res.data.config,
      },
    };
  });
}
